/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Vector3, Matrix4 } from 'three';
import { NavUtils } from './NavUtils';
const INTERNAL_MOUSE_PAN_FACTOR = 0.125;
/**
 * Navigator for camera roll movement
 */
export class PinchRollNavigator {
    constructor(cam, el) {
        this.speed = 1;
        this.mousePanFactor = 1;
        /**
         * Restrict navigator to a specific mouse buttons.
         * `0` is *left*, `1` is *middle* and `2` is *right* mouse button.
         */
        this.allowedMouseBtns = [2];
        this._enabled = true;
        this._calcLookAt = NavUtils.calcLookAt(() => this._cam);
        this._onPan = (event) => {
            const { mouseBtn } = event.detail;
            if (mouseBtn >= 0 && this.allowedMouseBtns.indexOf(mouseBtn) >= 0) {
                this._roll(event.detail.movementX * this.mousePanFactor * INTERNAL_MOUSE_PAN_FACTOR);
            }
        };
        this._onPinch = (event) => {
            this._roll(event.detail.angle);
        };
        this._cam = cam;
        const eventListenerOptions = { passive: true }; // edge and ie11 need identical options to match
        // listener for removal
        el.addEventListener('pinch', this._onPinch, eventListenerOptions);
        el.addEventListener('pan', this._onPan, eventListenerOptions);
        this.dispose = (() => {
            // @ts-ignore
            el.removeEventListener('pinch', this._onPinch, eventListenerOptions);
            // @ts-ignore
            el.removeEventListener('pan', this._onPan, eventListenerOptions);
        });
    }
    // tslint:disable-next-line:no-empty
    update() {
    }
    enable(enable) {
        this._enabled = enable;
    }
    _roll(angleDeg) {
        if (this._enabled) {
            const camera = this._cam;
            const angleRad = (angleDeg * Math.PI) / 180.0;
            const lookAt = this._calcLookAt();
            const dir = new Vector3();
            camera.getWorldDirection(dir);
            const rot = new Matrix4();
            rot.makeRotationAxis(dir, -angleRad * this.speed);
            camera.up.applyMatrix4(rot);
            camera.lookAt(lookAt);
        }
    }
}
//# sourceMappingURL=PinchRollNavigator.js.map